import Api from '../../shared/Api';

export interface IStylingUser {
    id: number;
    name: string;
    profileImageReference: string;
}

export default class StylingCalendarApi {
    static getStylingUsersByFirm(): Promise<IStylingUser[]> {
        return new Api().get('/views/stylinguser-calendars/by-firm').then((users: any) => {
            return users.stylingUsers;
        });
    }

    static getStylingCalendars(ids: number[], from: any, to: any) {
        let url =
            '/views/stylinguser-calendars?ids=' +
            ids.join('&ids=') +
            '&fromYear=' +
            from.year() +
            '&fromMonth=' +
            (from.month() + 1) +
            '&fromDay=' +
            from.date() +
            '&toYear=' +
            to.year() +
            '&toMonth=' +
            (to.month() + 1) +
            '&toDay=' +
            to.date();
        return new Api().get(url);
    }

    static createStylingUserCalendarItem(item: any) {
        return new Api().post('/views/stylingUser-calendars/items', {
            stylingUserId: item.stylingUserId,
            item: item
        });
    }

    static deleteStylingUserCalendarItem(item: any) {
        return new Api().delete('/views/stylingUser-calendars/items/' + item.id);
    }

    static updateStylingUserCalendarItem(item: any) {
        return new Api().put('/views/stylinguser-calendars/items/', {
            stylingUserId: item.stylingUserId,
            item: item
        });
    }
}
